import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useRef, useEffect } from "react";
import { useDisableScroll } from "../../../shared/hooks";
import { SkeletonLoader, SkeletonUnit } from "../../SkeletonLoader";
import { addRootToCards, concatUrl } from "../helpers";
import { hardCodedHeaderContent } from "./../productLinks";
import { ShopMenu, LearnMenu, BusinessMenu, registerButton, supportLink, guestMenu, AccountMenu } from "./DesktopMenuTopLevelItems";
import * as S from "./styles";
export var Menu;
!function (e) {
  e[e.None = 0] = "None", e[e.Shop = 1] = "Shop", e[e.Learn = 2] = "Learn", e[e.ForBusiness = 3] = "ForBusiness", e[e.Account = 4] = "Account";
}(Menu || (Menu = {}));
export var DesktopMenu = function DesktopMenu(_ref) {
  var e = _ref.loggedIn,
      n = _ref.isLoggingIn,
      o = _ref.onMenuOpen,
      t = _ref.onMenuClose,
      u = _ref.onSubMenuOpen,
      r = _ref.onSubMenuClose,
      s = _ref.onMenuItemClick,
      l = _ref.onLogout,
      a = _ref.root,
      i = _ref.ehsRoot,
      c = _ref.membership,
      d = _ref.accountLinks,
      p = _ref.topLevelLinks,
      m = _ref.renderLinkAs,
      M = _ref.headerContent,
      h = _ref.userName,
      _ref$hasPartialPipLoa = _ref.hasPartialPipLoad,
      L = _ref$hasPartialPipLoa === void 0 ? !1 : _ref$hasPartialPipLoa;

  var k = useRef(),
      _useState = useState(Menu.None),
      _useState2 = _slicedToArray(_useState, 2),
      g = _useState2[0],
      v = _useState2[1],
      C = function C(e) {
    return function () {
      var n = g === e ? Menu.None : e;
      v(n);
    };
  },
      f = C(Menu.None),
      R = g === Menu.Shop,
      b = g === Menu.Learn,
      E = g === Menu.ForBusiness,
      A = g === Menu.Account;

  useEffect(function () {
    g === Menu.None ? t && t() : o && o();
  }, [g, o, t]), useEffect(function () {
    var e = function e(_e) {
      var n;
      (null === (n = k.current) || void 0 === n ? void 0 : n.contains(_e.target)) || f();
    };

    return A ? document.addEventListener("mousedown", e) : document.removeEventListener("mousedown", e), function () {
      return document.removeEventListener("mousedown", e);
    };
  }, [A, f]), useDisableScroll(R || b || E);
  var B = addRootToCards((null == M ? void 0 : M.productCategories) || hardCodedHeaderContent.productCategories, a),
      P = (null == M ? void 0 : M.mainPromo) || hardCodedHeaderContent.mainPromo,
      N = Object.assign(Object.assign({}, P), {
    url: concatUrl(P.url, a)
  });
  return React.createElement(S.MenuWrapper, {
    "data-testid": "desktop-menu"
  }, React.createElement(S.MenuLeftHalf, null, (null == p ? void 0 : p.shop) ? (I = p.shop.label, React.createElement(ShopMenu, {
    active: R,
    label: I,
    slug: Menu.Shop,
    handleClick: C(Menu.Shop),
    handleClose: f,
    onSubMenuOpen: u,
    onSubMenuClose: r,
    onMenuItemClick: s,
    topLevelLinks: p,
    root: a,
    renderLinkAs: m,
    productCategories: B,
    mainPromo: N,
    closeMenu: f,
    hasPartialPipLoad: L
  })) : null, (null == p ? void 0 : p.learn) ? function (e) {
    return React.createElement(LearnMenu, {
      active: b,
      label: e,
      slug: Menu.Learn,
      handleClick: C(Menu.Learn),
      handleClose: f,
      root: a,
      renderLinkAs: m
    });
  }(p.learn.label) : null, (null == p ? void 0 : p.business) ? function (e) {
    return React.createElement(BusinessMenu, {
      active: E,
      label: e,
      slug: Menu.ForBusiness,
      handleClick: C(Menu.ForBusiness),
      handleClose: f,
      root: a,
      ehsRoot: i,
      renderLinkAs: m
    });
  }(p.business.label) : null), React.createElement(S.MenuRightHalf, null, (null == p ? void 0 : p.register) ? registerButton(p.register) : null, (null == p ? void 0 : p.support) ? supportLink(p.support) : null, React.createElement(S.RightSideWrapper, null, d ? !0 === n ? React.createElement(SkeletonLoader, {
    height: {
      value: 28,
      unit: SkeletonUnit.Pixel
    },
    width: {
      value: 100,
      unit: SkeletonUnit.Percentage
    },
    testId: "skeleton-loader"
  }) : e ? (H = d.account, React.createElement(AccountMenu, {
    accountMenuRef: k,
    active: A,
    openHandler: C(Menu.Account),
    onLogout: l,
    account: H,
    membership: c,
    root: a,
    renderLinkAs: m,
    userName: h
  })) : guestMenu(d.login) : null)));
  var H, I;
};
export default DesktopMenu;